import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainIndex from "./MainIndex";
import Login from "./pages/registerations/Registeration";
import EmailVerify from "./pages/registerations/EmailVerify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./global_styles.css";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { ConfigProvider } from "antd";
import NavigateToRoot from "./components/authentication/NavigateToRoot";
import { PrimeReactProvider } from "primereact/api";
import AutomaticLogout from "./components/authentication/AutomaticLogout";
import { Helmet } from "react-helmet";

import { UserProvider } from "./components/contexts/UserContext";
import { StaticHome } from "./pages/static home/StaticHome";
import MainLayout from "./components/layouts/MainLayout";
import PaymentAndDeliveryOptions from "./components/payment-and-delivery-options/PaymentAndDeliveryOptions";
import ReturnAndExchangePolicy from "./components/return-and-exchange-policy/ReturnAndExchangePolicy";
import PrivacyPolicy from "./components/privacy-policy/PrivacyPolicy";
import { FulfillmentLanding } from "./pages/fulfilment landing/FulfilmentLanding";
import ThankYou from "./components/static home/ThankYou";
 
const App = () => {
  return (
    <UserProvider>
      <MantineProvider>
        <Helmet>
          <title>ايكومبو شريك نجاحك في التجارة الالكترونية - ecombo</title>
        </Helmet>
        <ToastContainer />

        <ConfigProvider
          theme={{
            token: {
              // Seed Token
              colorPrimary: "rgba(89, 198, 201, 1)",
              borderRadius: 2,

              // Alias Token
              colorBgContainer: "white",
            },
          }}
        >
          <PrimeReactProvider>
            <Router>
              <AutomaticLogout>
                <Routes>
                  <Route path="/" element={<StaticHome />} />
                  <Route path="/:lang" element={<StaticHome />} />
                  <Route path="/fulfillment" element={<FulfillmentLanding />} />
                  <Route path="/:lang/fulfillment" element={<FulfillmentLanding />} />
                  <Route path="/:slug/:lang/*" element={<MainIndex />} />
                  <Route element={<MainLayout />}>
                    <Route path="/payment-and-delivery-options" element={<PaymentAndDeliveryOptions />} />
                    <Route path="/:lang/payment-and-delivery-options" element={<PaymentAndDeliveryOptions />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/return-and-exchange-policy" element={<ReturnAndExchangePolicy />} />
                    <Route path="/:lang/return-and-exchange-policy" element={<ReturnAndExchangePolicy />} />  
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route path="/:lang/thank-you" element={<ThankYou />} />
                  </Route>
                  <Route path="/:lang/auth/*" element={<Login />} />
                  <Route path="/:lang/email/verify" element={<EmailVerify />} />
                  <Route path="*" element={<NavigateToRoot />} />
                </Routes>
              </AutomaticLogout>
            </Router>
          </PrimeReactProvider>
        </ConfigProvider>
      </MantineProvider>
    </UserProvider>
  );
};

export default App;
